export * from './SuperHeroTertiaryCard';
